import { getAmplitudeInstance } from '../amplitudeHelpers';

type logGarminSendRouteTappedParams = {
  is_update?: boolean;
};

/**
 * When a user taps to Send to or Update on Garmin
 * @param params - Attributes to log with the amplitude event
 * @param params.is_update - TRUE indicates user is updating an existing sent Garmin route.
 */
const logGarminSendRouteTapped = ({ is_update }: logGarminSendRouteTappedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('garmin send route tapped', { 'is update': is_update }, callback);
};

export default logGarminSendRouteTapped;
